// platform.js
export const isNativeApp =
	(import.meta && import.meta.env && import.meta.env.VITE_PLATFORM === 'iosapp') ||
	!!(window && window.webkit && window.webkit.messageHandlers);
